import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text, Center } from '@chakra-ui/react';
import { MdArrowForward } from 'react-icons/md';

import Link from '@repo/ui-components/tailwind/Link';
import { LinkShape } from '@repo/utils/getLink';
import SanityBackgroundImage from '../../../atoms/SanityBackgroundImage';

export default function GradientImage({
  image,
  link,
  headline,
  arrowInset,
  flexStyleProps,
}) {
  const gradientGenerator = url =>
    `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.80) 89.56%), url(${url}), lightgray 50% / cover no-repeat;`;

  return (
    <SanityBackgroundImage
      w="full"
      h="full"
      gradientGenerator={gradientGenerator}
      image={image}
      maxImageWidth={800}
      borderRadius="lg"
    >
      <Flex
        as={Link}
        className="flex items-end justify-between h-full w-full"
        link={link}
        forceKeyboardNav
        {...flexStyleProps}
      >
        <Text
          textStyle="h4_5_6"
          as="h3"
          color="typography.lighter"
          noOfLines={2}
          h="max"
          textAlign="left"
          overflow="hidden"
          sx={{
            textWrap: 'wrap',
          }}
        >
          {headline}
        </Text>
      </Flex>
      <Center
        backgroundColor="brand.sunny"
        borderRadius="full"
        w="40px"
        h="40px"
        pos="absolute"
        bottom={arrowInset}
        right={arrowInset}
        pointerEvents="none"
      >
        <MdArrowForward size="24" />
      </Center>
    </SanityBackgroundImage>
  );
}

GradientImage.defaultProps = {
  arrowInset: '4',
  flexStyleProps: {
    pl: '6',
    pb: '6',
    pr: '14',
  },
};

GradientImage.propTypes = {
  image: PropTypes.shape({
    asset: PropTypes.shape({
      url: PropTypes.string,
    }),
    hotspot: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number,
    }),
    alt: PropTypes.string,
  }).isRequired,
  link: LinkShape.isRequired,
  headline: PropTypes.string.isRequired,
  arrowInset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  flexStyleProps: PropTypes.shape({}),
};
